export const AUTH_TOKEN = "authToken";
export const PRACTICE_TOKEN = "practiceToken"
export const FROM_TATAV_PRACTICE = "fromPractice"
export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const TERMS_AND_CONDITIONS_LINK =
  "https://www.tatvacare.in/terms-conditions/";
export const privacy_Policy_Link = "https://www.tatvacare.in/privacy-policy/";

export const PURCHASED = "Purchased";
export const NOT_PURCHASED = "Not Purchased";
export const PENDING = "Pending";
export const PAID = "Paid";
export const PLAN_EXPIRED = "Plan Expired";
export const PLAN_STATUS_MAP = {
  Pending: NOT_PURCHASED,
  Paid: PURCHASED,
  Expired: PLAN_EXPIRED,
};

export const myFeed = {
  dtoList: [
    {
      title: "lorem ipsum",
      category: null,
      id: 4002,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1708407503837.png?sig=eiNRCjwtfnma3vJdZfGbkSAXBeUeiZX1LwFLgsAD4DI%3D&se=2024-10-22T11%3A19%3A44Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl:
        "https://s3-alpha-sig.figma.com/img/2d9a/0650/ed65af75a47657269a92892006284519?Expires=1730678400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=nqil2kPtqCwu9m023D0ljpN-qv1wcFdIptKZkMXHQwtmhUatF3ofXNT~kGuW1UYRuxt4lOhHSVdWn6AugSe5iu7EqMN2Q2WwfOHpgjKdFOwGIlwnsPGwSNnQUkBMZB6CjX6ONNayexZDFhjgELEwH-hYrXF3qjReC8UvGCZYEvRwjiiXOeVmc1u1Uz68pjxxzJgezMrSC3NaxExhllWWf~HyZ3iP6xhn1hHydybhpT08Hg5dez0N1Z5hqiH9ULOZLf6O9oPj6nk-SS9T8OyeuaLuS54ocmEmyw~H8l3hg-zCwdODxjD3NVP5NVDCmTxNezBs4ir~LIV-RxyEE2B3eQ__",
      type: "Image",
      views: 10,
      likes: 1,
      status: "PUBLISHED",
      description: "<p>lorem ipsum lorem ipsum</p>",
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#neurology",
          id: 2,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#Gastroenterology",
          id: 3,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#cardiology",
          id: 4,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl:
        "https://diginextadmin72093uat.azureedge.net/#/shotsnews/list",
      readMoreLable: "%$^%$^%$%$%^$^%$^%",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2024-02-20",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: true,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title:
        "Major Determinants & their direct link to COVID-19 mortality in thoracic cancer patients",
      category: null,
      id: 13,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1649754297341.jpg?sig=2z4ELaTAD1Dse5RXod3WJoxD2P7MF%2FgfTHUUYGn56Jg%3D&se=2024-10-22T11%3A19%3A50Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl:
        "https://s3-alpha-sig.figma.com/img/2d9a/0650/ed65af75a47657269a92892006284519?Expires=1730678400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=nqil2kPtqCwu9m023D0ljpN-qv1wcFdIptKZkMXHQwtmhUatF3ofXNT~kGuW1UYRuxt4lOhHSVdWn6AugSe5iu7EqMN2Q2WwfOHpgjKdFOwGIlwnsPGwSNnQUkBMZB6CjX6ONNayexZDFhjgELEwH-hYrXF3qjReC8UvGCZYEvRwjiiXOeVmc1u1Uz68pjxxzJgezMrSC3NaxExhllWWf~HyZ3iP6xhn1hHydybhpT08Hg5dez0N1Z5hqiH9ULOZLf6O9oPj6nk-SS9T8OyeuaLuS54ocmEmyw~H8l3hg-zCwdODxjD3NVP5NVDCmTxNezBs4ir~LIV-RxyEE2B3eQ__",
      type: "Image",
      views: 14,
      likes: 0,
      status: "PUBLISHED",
      description:
        "Data capitalised on TERAVOLT, tumour-specific registry has shown that COVID-19 infection puts patients with thoracic malignancy at increased risk of mortality. Out of 73 analysed variables, seven major determinants of COVID-19 mortality were identified. Given the ever-evolving nature of COVID-19, this comprehensive and powered prognostication system will act as a useful tool for clinicians to tailor specific oncology treatment for their patients. ",
      tags: [
        {
          tagName: "#COVID-19",
          id: 68,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#thoracic",
          id: 76,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#cancer",
          id: 270,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: "https://www.jto.org/article/S1556-0864(22)00033-8/fulltext",
      readMoreLable: "Read more at JTO",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2022-04-12",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: true,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title:
        "Atezolizumab & Neoadjuvant GC: A Promising Regimen in Muscle-invasive Bladder Cancer",
      category: null,
      id: 14,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1649755393979.jpg?sig=lLWoVL7RCUFn2hW7DPnvu1XdU8r1osY7cOPt4TRaBmk%3D&se=2024-10-22T11%3A19%3A52Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl:
        "https://s3-alpha-sig.figma.com/img/2d9a/0650/ed65af75a47657269a92892006284519?Expires=1730678400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=nqil2kPtqCwu9m023D0ljpN-qv1wcFdIptKZkMXHQwtmhUatF3ofXNT~kGuW1UYRuxt4lOhHSVdWn6AugSe5iu7EqMN2Q2WwfOHpgjKdFOwGIlwnsPGwSNnQUkBMZB6CjX6ONNayexZDFhjgELEwH-hYrXF3qjReC8UvGCZYEvRwjiiXOeVmc1u1Uz68pjxxzJgezMrSC3NaxExhllWWf~HyZ3iP6xhn1hHydybhpT08Hg5dez0N1Z5hqiH9ULOZLf6O9oPj6nk-SS9T8OyeuaLuS54ocmEmyw~H8l3hg-zCwdODxjD3NVP5NVDCmTxNezBs4ir~LIV-RxyEE2B3eQ__",
      type: "Image",
      views: 10,
      likes: 1,
      status: "PUBLISHED",
      description:
        "A multicentre, single-arm, Phase-II trial demonstrated that the addition of atezolizumab to traditional Neoadjuvant gemcitabine and cisplatin (GC) combination appears to be safe and effective in patients with muscle-invasive bladder cancer. This new regimen gave promising results with a high rate of non-muscle-invasive downstaging (69%), along with improved relapse-free survival in muscle-invasive and metastatic bladder cancer.",
      tags: [
        {
          tagName: "#Oncology",
          id: 7,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#bladder",
          id: 22,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#neoadjuvant",
          id: 23,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#muscle-invasive",
          id: 26,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#metastatic",
          id: 30,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#Atezolizumab",
          id: 31,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#combotherapy",
          id: 33,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: "https://ascopubs.org/doi/abs/10.1200/jco.21.01485",
      readMoreLable: "Read more",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2022-04-12",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: true,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
  ],
  totalPage: 1,
  size: 3,
  totalRecords: 3,
  currentPageNumber: 0,
  trendingStatusCount: 0,
};
export const AllNews = {
  dtoList: [
    {
      title: "lorem ipsum",
      speciality: [
        {
          id: 45,
          code: "Cardiology",
          displayName: "Cardiology",
        },
        {
          id: 47,
          code: "Dermatology",
          displayName: "Dermatology",
        },
        {
          id: 48,
          code: "Ear, Nose and Throat",
          displayName: "E.N.T.",
        },
        {
          id: 50,
          code: "Endocrinology",
          displayName: "Endocrinology",
        },
        {
          id: 51,
          code: "Gastroenterology",
          displayName: "Gastroenterology",
        },
        {
          id: 503,
          code: "Hepatology",
          displayName: "Hepatology",
        },
        {
          id: 498,
          code: "Infectious Disease",
          displayName: "Infectious Disease",
        },
        {
          id: 57,
          code: "Nephrology",
          displayName: "Nephrology",
        },
        {
          id: 58,
          code: "Neurology",
          displayName: "Neurology",
        },
        {
          id: 61,
          code: "Obstetrics and Gynaecology",
          displayName: "Gynaecology",
        },
        {
          id: 64,
          code: "Oncology",
          displayName: "Oncology",
        },
        {
          id: 62,
          code: "Ophthalmology",
          displayName: "Ophthalmology",
        },
        {
          id: 63,
          code: "Orthopaedics",
          displayName: "Orthopaedics",
        },
        {
          id: 72,
          code: "Pulmonology",
          displayName: "Pulmonology",
        },
        {
          id: 80,
          code: "Rheumatology",
          displayName: "Rheumatology",
        },
      ],
      id: 4002,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1708407503837.png?sig=un3Q466ipnX6nMUefiW%2BcRVng8xwIku6K73f7v7Ax3k%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 10,
      likes: 2,
      status: "PUBLISHED",
      description: "<p>lorem ipsum lorem ipsum</p>",
      isMapped: false,
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#neurology",
          id: 2,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#Gastroenterology",
          id: 3,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#cardiology",
          id: 4,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl:
        "https://diginextadmin72093uat.azureedge.net/#/shotsnews/list",
      readMoreLable: "%$^%$^%$%$%^$^%$^%",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2024-02-20",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: "Testing",
      speciality: [
        {
          id: 45,
          code: "Cardiology",
          displayName: "Cardiology",
        },
      ],
      id: 4001,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1708345896042.jpg?sig=oZGqKiXzNI6HpVp7xzmcB6%2BlySeqbEzDuNkUGBmQ2n0%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 11,
      likes: 1,
      status: "PUBLISHED",
      description:
        "<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam facilis error dolorum odit quas ipsa doloribus, sed suscipit consequatur mollitia eligendi maxime vero commodi veniam expedita ducimus, exercitationem asperiores ut?</p>",
      isMapped: false,
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#neurology",
          id: 2,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#cardiology",
          id: 4,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl:
        "https://diginextadmin72093uat.azureedge.net/#/shotsnews/list",
      readMoreLable: "Testing Demo",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2024-02-19",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: "testestetse",
      speciality: [
        {
          id: 57,
          code: "Nephrology",
          displayName: "Nephrology",
        },
      ],
      id: 3978,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1694186546052.png?sig=3VlU9jNulBz9qqx9Qej9WsLWlTx3Eq7KFq5LBz%2FHOrg%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 4,
      likes: 0,
      status: "PUBLISHED",
      description: "<p>testestetse</p>",
      isMapped: false,
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: null,
      readMoreLable: null,
      uploadedBy: null,
      isFullScreenContent: true,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-09-08",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title:
        "Long-Term Gastrointestinal Manifestations Post-Recovery from COVID-19",
      speciality: [
        {
          id: 61,
          code: "Obstetrics and Gynaecology",
          displayName: "Gynaecology",
        },
      ],
      id: 4000,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1701153206807.jpg?sig=M9aiN90l06pGCjInHwuyQMUfa8m8iYOTgz4bDv0MyGc%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 15,
      likes: 1,
      status: "PUBLISHED",
      description:
        '<p><span style="color: rgb(73, 80, 87);">A large-scale observational study concluded that Post-traumatic stress disorder (PTSD), as indicated by an IES-R score exceeding 33, was observed in 41.4% of participants in connection to their COVID-19 illness encounters. Notably, individuals exhibiting PTSD symptoms demonstrated a higher prevalence of Disorders of Gut-Brain Interaction (DGBI) and increased severity of GI symptoms.</span></p>',
      isMapped: false,
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#Gastroenterology",
          id: 3,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#cardiology",
          id: 4,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: "https://www.google.com",
      readMoreLable: "news",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-11-28",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title:
        "Recently approved Brexpiprazole shows promise as a treatment for agitation in Alzheimer Dementia",
      speciality: [
        {
          id: 57,
          code: "Nephrology",
          displayName: "Nephrology",
        },
        {
          id: 61,
          code: "Obstetrics and Gynaecology",
          displayName: "Gynaecology",
        },
        {
          id: 72,
          code: "Pulmonology",
          displayName: "Pulmonology",
        },
      ],
      id: 3982,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1694435509863.jpg?sig=%2FNdE3K4%2BLrWq3OX02HUNcdxbQlyPCfzbMmluDf7c2Pc%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 20,
      likes: 0,
      status: "PUBLISHED",
      description:
        "<p>President Droupadi Murmu hosted the G20 gala dinner on Saturday at Bharat Mandapam, the venue for the G20 Summit to which several dignitaries, including some non-BJP leaders invited. Among the top non-BJP leaders who attended the dinner were&nbsp;Bihar Chief Minister Nitish Kumar and his counterparts - Hemant Soren, Mamata Banerjee, MK Stalin and Sukhvinder Singh Sukhu.&nbsp;</p><p>Interestingly, Himachal Pradesh CM and Congress leader Sukhu attended the dinner party.</p><p><br></p>",
      isMapped: false,
      tags: [
        {
          tagName: "#Gastroenterology",
          id: 3,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl:
        "https://www.news-medical.net/condition/Artificial-Intelligence",
      readMoreLable: "News",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-09-11",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: "Trending Content Testing 7",
      speciality: [
        {
          id: 57,
          code: "Nephrology",
          displayName: "Nephrology",
        },
      ],
      id: 3977,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1693920790058.jpg?sig=TqSb5TWhKpNlA%2F%2BtTJ7nDIvdmYOIi%2Fnmxq%2BgP0ecZNM%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 18,
      likes: 0,
      status: "PUBLISHED",
      description: "<p>Trending Content Testing</p>",
      isMapped: false,
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: null,
      readMoreLable: null,
      uploadedBy: null,
      isFullScreenContent: true,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-09-05",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: "Testing On UAT",
      speciality: [
        {
          id: 57,
          code: "Nephrology",
          displayName: "Nephrology",
        },
      ],
      id: 3981,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1694426448474.jpg?sig=ivtQyCRedoL2z9oGYvJkeiuC7gwtWC8BjGy%2Bh%2FoJF4E%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 5,
      likes: 0,
      status: "PUBLISHED",
      description: "<p>Testing On UAT</p>",
      isMapped: false,
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: "https://www.youtube.com/",
      readMoreLable: "Testing",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-09-11",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title:
        "Kerala is the only state to include avoided portions by NCERT from school textbooks.",
      speciality: [
        {
          id: 72,
          code: "Pulmonology",
          displayName: "Pulmonology",
        },
      ],
      id: 3980,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1694418204274.jpg?sig=03Sna4orxYDr8shm%2B2aYfjVBjt3fYEBLFbXMbjQreko%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 4,
      likes: 0,
      status: "PUBLISHED",
      description:
        '<p><span style="color: rgb(0, 0, 0);">Sivankutty said the NEP 2020 has not been completely accepted in the country as Tamil Nadu has rejected it in entirety and Karnataka has only agreed to implement some portions of it.</span></p>',
      isMapped: false,
      tags: [
        {
          tagName: "#neurology",
          id: 2,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#Gastroenterology",
          id: 3,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: "https://www.google.com",
      readMoreLable: "News",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-09-11",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: "full news",
      speciality: [
        {
          id: 51,
          code: "Gastroenterology",
          displayName: "Gastroenterology",
        },
      ],
      id: 3964,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1693817850182.jpg?sig=QwxekPdq6QlLdbFl4NnJOb24mAWGTsgUp9jrvq1gOeM%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 6,
      likes: 0,
      status: "PUBLISHED",
      description: "<p>Test</p>",
      isMapped: false,
      tags: [
        {
          tagName: "#HerbalInjection",
          id: 4924,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: null,
      readMoreLable: null,
      uploadedBy: null,
      isFullScreenContent: true,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-09-04",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: "trestet",
      speciality: [
        {
          id: 57,
          code: "Nephrology",
          displayName: "Nephrology",
        },
      ],
      id: 3979,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1694414673458.jpg?sig=Zj89eWl0N50FwDGFFQ%2F8dlWItl1%2B9E1vcZwBFVn00F0%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 5,
      likes: 0,
      status: "PUBLISHED",
      description: "<p>trestet</p>",
      isMapped: false,
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: "https://www.youtube.com/",
      readMoreLable: "Testing Views",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-09-11",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: "Sheduled video news",
      speciality: [
        {
          id: 72,
          code: "Pulmonology",
          displayName: "Pulmonology",
        },
      ],
      id: 3957,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1692941339907.mp4?sig=elilIvD2XoUnMm3cBqx5cllS0Gre8KqJSoFgvdSZ2S4%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl:
        "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/thumbnail/1692941337630.jpg?sig=kuQArwhoUaGnwsEgn76WBuAUlu0uE95FGbbsq%2BH92es%3D&se=2024-11-12T08%3A18%3A48Z&sv=2019-02-02&sp=r&sr=b",
      type: "Video",
      views: 6,
      likes: 0,
      status: "PUBLISHED",
      description: "<p>test</p>",
      isMapped: false,
      tags: [
        {
          tagName: "#Gastroenterology",
          id: 3,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#neurology",
          id: 2,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#OCTA",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: "https://www.google.com",
      readMoreLable: "sheduled",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-08-25",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: false,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
  ],
  totalPage: 1,
  size: 13,
  totalRecords: 13,
  currentPageNumber: 0,
  trendingStatusCount: 0,
};

export const trendingNews = {
  dtoList: [
    {
      title: "lorem ipsum",
      category: null,
      id: 4002,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1708407503837.png?sig=QbHq3ZBR8MPHPy2nUhsEM7qcsHyp6FTptJFRU6zuu80%3D&se=2024-10-22T11%3A27%3A21Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 10,
      likes: 1,
      status: "PUBLISHED",
      description: "<p>lorem ipsum lorem ipsum</p>",
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#neurology",
          id: 2,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#Gastroenterology",
          id: 3,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#cardiology",
          id: 4,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl:
        "https://diginextadmin72093uat.azureedge.net/#/shotsnews/list",
      readMoreLable: "%$^%$^%$%$%^$^%$^%",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2024-02-20",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: true,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: "Testing",
      category: null,
      id: 4001,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1708345896042.jpg?sig=ey4zb3fZbmVNyr6tjiaJHGKG9IFnLp7Y7GGwWDb3fVM%3D&se=2024-10-22T11%3A27%3A21Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 11,
      likes: 1,
      status: "PUBLISHED",
      description:
        "<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam facilis error dolorum odit quas ipsa doloribus, sed suscipit consequatur mollitia eligendi maxime vero commodi veniam expedita ducimus, exercitationem asperiores ut?</p>",
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#neurology",
          id: 2,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#cardiology",
          id: 4,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl:
        "https://diginextadmin72093uat.azureedge.net/#/shotsnews/list",
      readMoreLable: "Testing Demo",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2024-02-19",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: true,
      isViewed: true,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: "Trending Content Testing 7",
      category: null,
      id: 3977,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1693920790058.jpg?sig=PGLE4K5fG%2F86cUNEiURoOK%2B3bd%2B%2BgU3Yyz64qPKPcOY%3D&se=2024-10-22T11%3A27%3A21Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 18,
      likes: 0,
      status: "PUBLISHED",
      description: "<p>Trending Content Testing</p>",
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: null,
      readMoreLable: null,
      uploadedBy: null,
      isFullScreenContent: true,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-09-05",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: true,
      isViewed: true,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title:
        "Recently approved Brexpiprazole shows promise as a treatment for agitation in Alzheimer Dementia",
      category: null,
      id: 3982,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1694435509863.jpg?sig=A8fSmwoz7VAy4jhixuLOrDY9zULPb6LPGjLzAeaJaGY%3D&se=2024-10-22T11%3A27%3A21Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl: "",
      type: "Image",
      views: 18,
      likes: 0,
      status: "PUBLISHED",
      description:
        "<p>President Droupadi Murmu hosted the G20 gala dinner on Saturday at Bharat Mandapam, the venue for the G20 Summit to which several dignitaries, including some non-BJP leaders invited. Among the top non-BJP leaders who attended the dinner were&nbsp;Bihar Chief Minister Nitish Kumar and his counterparts - Hemant Soren, Mamata Banerjee, MK Stalin and Sukhvinder Singh Sukhu.&nbsp;</p><p>Interestingly, Himachal Pradesh CM and Congress leader Sukhu attended the dinner party.</p><p><br></p>",
      tags: [
        {
          tagName: "#Gastroenterology",
          id: 3,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "",
          id: 4904,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl:
        "https://www.news-medical.net/condition/Artificial-Intelligence",
      readMoreLable: "News",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-09-11",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: true,
      isViewed: true,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title:
        "Effectiveness of biosimilar Ranibizumab monotherapy in the treatment ROP",
      category: null,
      id: 3840,
      url: "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/1682424447694.jpg?sig=MTEYf5kTz2E%2FbrAzdvU0KWRlBRf0b3opz%2Fxxb%2Fgvi2w%3D&se=2024-10-22T11%3A27%3A21Z&sv=2019-02-02&sp=r&sr=b",
      thumbnailUrl:
        "https://diginextappstorage28uat.blob.core.windows.net/tatvashots/news/thumbnail/1682424447694.jpg?sig=xZC7PQEr%2Bcoy5DYZY8XvckH9Bd%2BckIvnA7e15HVdG5I%3D&se=2024-10-22T11%3A27%3A21Z&sv=2019-02-02&sp=r&sr=b",
      type: "Image",
      views: 23,
      likes: 1,
      status: "PUBLISHED",
      description:
        "In this study published in Indian Journal of Ophthalmology, the biosimilar drug Ranibizumab has shown promise in effectively treating zone 1 and zone 2 posterior Retinopathy of Prematurity (ROP), with results comparable to the innovator drug Ranibizumab. Ranibizumab showed no safety concerns in the short-term with cost-benefit advantages.",
      tags: [
        {
          tagName: "#retinopathy",
          id: 312,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#ranibizumab",
          id: 782,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
        {
          tagName: "#ROP",
          id: 3186,
          status: null,
          category: null,
          count: null,
          popular: false,
        },
      ],
      readMoreUrl: "https://doi.org/10.4103/ijo.IJO_973_22",
      readMoreLable: "Read more at IJO",
      uploadedBy: null,
      isFullScreenContent: false,
      isPopularTagPage: false,
      isFeedbackForm: null,
      createdAt: "2023-04-25",
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: false,
      isBookmarked: false,
      isViewed: true,
      isAccess: null,
      isTrending: false,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
    {
      title: null,
      category: null,
      id: null,
      url: null,
      thumbnailUrl: null,
      type: null,
      views: 0,
      likes: 0,
      status: null,
      description: null,
      tags: [
        {
          tagName: "#hepatology",
          id: 1,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#neurology",
          id: 2,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#Gastroenterology",
          id: 3,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#cardiology",
          id: 4,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#nephrology",
          id: 5,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#gynaecology",
          id: 6,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#Oncology",
          id: 7,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#gutBacterium",
          id: 8,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#AkkemansiaMuciniphila",
          id: 9,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#biomarker",
          id: 10,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
        {
          tagName: "#stratification",
          id: 11,
          status: null,
          category: null,
          count: null,
          popular: true,
        },
      ],
      readMoreUrl: null,
      readMoreLable: null,
      uploadedBy: null,
      isFullScreenContent: null,
      isPopularTagPage: true,
      isFeedbackForm: null,
      createdAt: null,
      updatedAt: null,
      scheduledPublishedDate: null,
      isLiked: null,
      isBookmarked: null,
      isViewed: null,
      isAccess: null,
      isTrending: null,
      trendingStartDate: null,
      trendingEndDate: null,
      country: null,
    },
  ],
  totalPage: 1,
  size: 13,
  totalRecords: 13,
  currentPageNumber: 0,
  trendingStatusCount: 0,
};

export const MESSAGE_KEY = 'message_key';
export const COUNTRY_ID_KEY = "country_id";
export const INDIAN_COUNTRY_ID = 1;
/** Country code → id: IN/91→1, NPL/977→2, ZAF/27→3, PHL/63→4 */
export const COUNTRY_CODE_TO_ID: Record<string, number> = { "91": 1, "977": 2, "27": 3, "63": 4 };